module.exports = __webpack_public_path__ + "static/media/userAvatar.5add0b7d.jpg";